import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Helper } from '@portal/util';
import { PortalFieldConfig } from '@portal/form/data-access';

export function nricValidator(control: AbstractControl): ValidationErrors | null {
  const { value } = control;

  if (!value || Helper.isNricNumber(value)) {
    return null;
  }

  return { nric: true };
}

export function uniqueNricInArrayValidator(control: AbstractControl, field: PortalFieldConfig): ValidationErrors | null {
  const value = control.getRawValue();
  if (!Array.isArray(value)) return null;
  const nricList: string[] = value.map(o => o?.['nricNumber'] || '');
  const duplicated = findDuplicates(nricList);
  return duplicated.length > 0 ? { uniqueNricInArray: duplicated } : null;
}

function findDuplicates(arr: string[]): string[] {
  const frequencyMap = new Map<string, number>();
  const duplicates: string[] = [];

  arr.forEach(item => {
    const count = (frequencyMap.get(item) || 0) + 1;
    frequencyMap.set(item, count);
    if (count === 2) {
      duplicates.push(item);
    }
  });

  return duplicates;
}
